// extracted by mini-css-extract-plugin
export default {"buttonDefault":"ButtonDefault_buttonDefault__YOS+v","buttonSecundary":"ButtonDefault_buttonSecundary__Kwudw"};